import React from 'react';

import { Translate } from '@travel/translation';
import Media from '@travel/traveler-core/components/Media';
import cx from '@travel/ui/utils/classnames';

import UserNotFound from 'components/NoReviewsIllustration';
import NoReviews from 'components/UserNotFoundIllustration';

import { ApiErrorCodes } from 'store/apiTypes';

import styles from './multiErrorDisplay.module.scss';

type ErrorDisplayProps = {
  errorType?: 'noPostedReviews' | 'userHasWithdrawn';
  containerClassName?: string;
};

const ERROR_LIST = {
  noPostedReviews: {
    alt: '',
    imageUrl: '',
    errorMsg: <Translate id="MyReview.Empty" />,
    svg: <NoReviews />,
  },
  userHasWithdrawn: {
    alt: '',
    imageUrl: '',
    errorMsg: <Translate id={ApiErrorCodes.USER_WITHDRAWN} />,
    svg: <UserNotFound />,
  },
  default: {
    alt: '',
    imageUrl: '',
    errorMsg: <Translate id="MyReview.Empty" />,
    svg: <NoReviews />,
  },
} as const;

const MultiErrorDisplay: React.FC<ErrorDisplayProps> = ({
  errorType = 'noPostedReviews',
  containerClassName,
}) => {
  const error = ERROR_LIST[errorType as keyof typeof ERROR_LIST] || ERROR_LIST.default;

  return (
    <div
      className={cx(styles.errorContainer, containerClassName)}
      data-testid="multiErrorDisplay-container"
    >
      <div className={styles.imageSection} data-testid="multiErrorDisplay-imageSection">
        {error.imageUrl ? (
          <Media
            media={{ url: error.imageUrl, alt: error.alt, type: 'IMAGE' }}
            className={styles.errorImage}
            isDisableLazyload
            isDisableSrcSetCache
            fetchPriority="high"
          />
        ) : (
          error?.svg
        )}
      </div>
      <div className={styles.messageSection} data-testid="multiErrorDisplay-messageSection">
        <p className={styles.errorMessage} data-testid="multiErrorDisplay-message">
          {error.errorMsg}
        </p>
      </div>
    </div>
  );
};

export default MultiErrorDisplay;
